import React from 'react';

const NotificationBell = ({ count = 0, onClick, buttonRef }) => (
  <button
    type="button"
    className="notification-button"
    title="Notifications"
    onClick={onClick}
    ref={buttonRef}
  >
    <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V4a2 2 0 10-4 0v1.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
      />
    </svg>
    {count > 0 && <span className="notification-badge">{count}</span>}
  </button>
);

export default NotificationBell;
